import React from 'react';
import Logo from './Logo';
import styled from 'styled-components';
import {headerHeight, tabletWidth} from '../../mixins';


const StyledHeader = styled.div`
   position: fixed;
   top: 0;
   left: 0;
   right: 0;
   height: ${headerHeight};
   background-color: ${props => props.bgColor};
   display: flex;
   justify-content: space-between;
   align-items: center;
   padding: 10px 12px;
   box-sizing: border-box;
   z-index: 1600;
   //pointer-events: none;
   
     @media screen and (min-width: ${tabletWidth}) {
        background-color: #fff;
        pointer-events: initial;
  }

  svg {
    width: 40px;
    height: auto;
    pointer-events: initial;
  }
`


const Header = ({children, bgColor}) => {

    return (
        <StyledHeader bgColor={bgColor}>
            <Logo/>
            {children}
        </StyledHeader>
    );
}

export default Header;
